export default "/assets/images/mila-room-showcase-03.webp?0195b75d7b16f1e33cca3fa96c5a6fc4";